import { render, staticRenderFns } from "./OnlinePayment.vue?vue&type=template&id=2529952b&"
import script from "./OnlinePayment.vue?vue&type=script&lang=js&"
export * from "./OnlinePayment.vue?vue&type=script&lang=js&"
import style0 from "./OnlinePayment.vue?vue&type=style&index=0&id=2529952b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports